var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8978 11.7864H2.36436C2.26615 11.7864 2.18579 11.8668 2.18579 11.965V13.3043C2.18579 13.4025 2.26615 13.4828 2.36436 13.4828H15.8733L12.6523 17.5677C12.5608 17.6837 12.6434 17.8578 12.7929 17.8578H14.4112C14.5206 17.8578 14.6233 17.8087 14.6925 17.7217L18.4603 12.9427C18.8286 12.4739 18.4961 11.7864 17.8978 11.7864ZM18.4358 6.51856H4.92686L8.14785 2.43373C8.23936 2.31766 8.15677 2.14355 8.00722 2.14355H6.38892C6.27954 2.14355 6.17686 2.19266 6.10767 2.27972L2.33981 7.05873C1.9715 7.52748 2.30409 8.21498 2.90008 8.21498H18.4358C18.534 8.21498 18.6144 8.13463 18.6144 8.03641V6.69713C18.6144 6.59891 18.534 6.51856 18.4358 6.51856Z",
    fill: "#13C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/Swap.91b981c9f13c2efecac70f1114d85e61.svg";
export { ForwardRef as ReactComponent };